import React from 'react';
import { Link } from 'react-router-dom';
import './Unauthorized.css';

const Unauthorized = () => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <h1>Access Denied!!!!!!!!!!</h1>
        <div className="unauthorized-icon">
          <span>403</span>
        </div>
        <p>
          You don't have permission to access this page!
        </p>
        <div className="unauthorized-actions">
          <Link to="/dashboard" className="btn-primary">
            Go to Dashboard
          </Link>
          <Link to="/" className="btn-secondary">
            Return to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;